var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65708 22.2352V18.6679C8.65708 17.7573 9.4007 17.019 10.318 17.019H13.6712C14.1117 17.019 14.5342 17.1928 14.8457 17.502C15.1572 17.8112 15.3322 18.2306 15.3322 18.6679V22.2352C15.3294 22.6138 15.4789 22.9779 15.7476 23.2465C16.0163 23.5152 16.3819 23.6663 16.7633 23.6663H19.051C20.1194 23.6691 21.1451 23.2497 21.9015 22.5006C22.658 21.7516 23.0832 20.7345 23.0832 19.6738V9.51101C23.0832 8.65421 22.7006 7.84149 22.0386 7.29179L14.2562 1.12152C12.9024 0.0396631 10.9628 0.0745936 9.64946 1.20448L2.04468 7.29179C1.35137 7.82529 0.936982 8.64042 0.916504 9.51101V19.6634C0.916504 21.8742 2.72178 23.6663 4.94871 23.6663H7.18418C7.97627 23.6663 8.62 23.0319 8.62574 22.2456L8.65708 22.2352Z",
    fill: "#3765A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.0a4c89a712211afaed67c18f11037cab.svg";
export { ForwardRef as ReactComponent };